import m from "../../geodata/es2015/zambiaHigh";
window.am4geodata_zambiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/zambiaHigh.js
// module id = null
// module chunks = 